// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"719":"a8664232","829":"be70db7a","919":"ba3dd43a"}[chunkId] + ".chunk.js";
};